import React, { useState } from 'react';
import { Form, Input } from 'antd';
import { Select, MenuItem } from '@mui/material';
import { linkBankAccountGenericMulti } from '../../../../../../helpers/newBankAccount';
import GenericModal from '../../../../../../components/buttons/genericModal';
import LoadingButton from '@mui/lab/LoadingButton';
import SelectBankAccountTag from '../../../../../../components/specific/customTags/selectBankAccountTag';
import SelectBankAccountPurpose from '../../../../../../components/specific/customTags/selectBankAccountPurpose';
import Stack from "@mui/material/Stack";

const { Option } = Select;

function LinkToDashboard({
  source,
  sourceId,
  institutionName,
  accountDescription,
  entityName,
  onLinkToDashboardSuccess,
  accountNumberLast4,
  groups,
  flattenedTags,
  groupsLoading,
  flattenedTagsLoading
}) {
  const [visible, setVisible] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [selectedPurpose, setSelectedPurpose] = useState(undefined);
  const [selectedTags, setSelectedTags] = useState([]);
  const [accountName, setAccountName] = useState(accountDescription)


  const onFormSubmitCloseModal = () => {
    let tagIds = []
    for (let fullTagId of selectedTags) {
      if (fullTagId.startsWith('tag_')) {
        tagIds.push(parseInt(fullTagId.replace('tag_', ''), 10));
      }
    }
    // setSubmitLoading(true);
    linkBankAccountGenericMulti({
      accountPurposeId0: selectedPurpose,
      description0: accountName,
      source0: source,
      sourceId0: sourceId,
      agreement: false,
      genericTags0: tagIds,
    }, [0],
      (responseData) => {
        setSubmitLoading(false);
        setVisible(false)
        onLinkToDashboardSuccess();
      },
      // error callback when POST fails
      () => {
        setSubmitLoading(false);
      });
  };
  const getValidatedLast4 = () => {
    const last4 = accountNumberLast4;
    return last4 && last4.length > 3 && last4.length < 7 ? `(...${last4})` : "";
  }

  return (
    <GenericModal
      size="md"
      visible={visible}
      handleCancelModal={() => setVisible(false)}
      showModal={() => setVisible(true)}
      button={"Link to dashboard"}
      modalTitle={`Link ${accountDescription} to dashboard`}
      modalBody={
        <Form
          layout="vertical"
          name="basic"
          onFinish={onFormSubmitCloseModal}
          autoComplete="off"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
        >

          <Form.Item
            name="institution"
            label={<label style={{ margin: "5px" }}>Institution</label>}
            style={{ display: "flex", flexDirection: "row", margin: "0px" }}
          >
            {institutionName}
          </Form.Item>
          <Form.Item
            name="account"
            label={<label style={{ margin: "5px" }}>Account</label>}
            style={{ display: "flex", flexDirection: "row", margin: "0px" }}
          >
            {accountDescription} {getValidatedLast4()}
          </Form.Item>
          <Form.Item
            name="entity"
            label={<label style={{ margin: "5px" }}>Entity</label>}
            style={{ display: "flex", flexDirection: "row", margin: "0px" }}
          >
            {entityName}
          </Form.Item>
          <Form.Item
            name="name"
            initialValue={accountDescription}
            label={<label style={{ margin: "5px" }}>Name</label>}
            style={{ display: "flex", flexDirection: "row", margin: "0px" }}
            rules={[
            ]}
          >
            <Input onChange={(e) => setAccountName(e.target.value)} />
          </Form.Item>
          <Form.Item
            name="purpose"
            label={<label style={{ margin: "5px" }}>Purpose</label>}
            style={{ display: "flex", flexDirection: "row", margin: "0px" }}
            rules={[
            ]}
          >
            <SelectBankAccountPurpose
              placeholder={"Select purpose of account"}
              onChange={setSelectedPurpose}
            />
          </Form.Item>
          <Form.Item
            name="tags"
            label={<label style={{ margin: "5px" }}>Placement</label>}
            style={{ display: "flex", flexDirection: "row", margin: "0px" }}
            rules={[
            ]}
          >
            <SelectBankAccountTag
              groups={groups}
              customTags={flattenedTags}
              loading={flattenedTagsLoading || groupsLoading}
              placeholder={"Select tags to associated with this account"}
              includeUncategorized={false}
              multiSelect={true}
              required={true}
              onChange={setSelectedTags}
            />
          </Form.Item>
          <Form.Item>
            <LoadingButton
              htmlType="submit"
              loadingPosition="start"
              loading={submitLoading}
              disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
              sx={{ fontSize: 14, width: '100px', textTransform: 'none' }}
            >
              Submit
            </LoadingButton>
          </Form.Item>
        </Form>
      }
    />
  )
}

export default LinkToDashboard;
